import AdminUserTransaction from 'components/Admin/UserTransAction/AdminUserTransaction';

const AdminUserTransactionPage = () => {
	return <AdminUserTransaction />;
};

export default AdminUserTransactionPage;
